// extracted by mini-css-extract-plugin
module.exports = {"error":"_1MZc0VS"};